import React from "react";
import StyleGuideLayout from "./StyleGuideLayout";
import StyleGuidePage from "./StyleGuidePage";

const StyleGuide: React.FC = () => (
  <StyleGuideLayout>
    <StyleGuidePage />
  </StyleGuideLayout>
);

export default StyleGuide;
export * from "./StyleGuidePage";
